<template>
  <div>
    <router-link
      :to="item.href"
      class="sidebar-menu-subitem fs12-400"
      :class="{ 'is-active': isActive }"
    >
      {{ item.title }}
    </router-link>
  </div>
</template>

<script>
import { getBaseRouteForMenuSelection } from '~/helpers/common';

export default {
  name: "SidebarMenuSubitem",
  props: ["data"],
  data() {
    return { item: this.data ?? {} };
  },
  computed: {
    isActive() {
      // Check if current route path matches the item's href, e.g., /reports
      const basePath = this.item?.href?.split("?")[0]; // Remove query params if any
      let currentPath = getBaseRouteForMenuSelection(this.$route?.path || "/");
      return currentPath === basePath;
    },
  },
  watch: {
    data: {
      handler(newVal) {
        this.item = newVal;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global/global.scss";

.sidebar-menu-subitem {
  width: 100%;
  text-align: left;
  padding: 6px 0 6px 25px;
  color: $gray-80;
  text-decoration: none;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
}

.sidebar-menu-subitem.is-active {
  font-weight: 700;
  color: black;
}
</style>